import React from "react";

import {
    InterdocumentCheckType,
    InterdocumentIssueSeverity,
} from "../../../../../Engine/Core/ErrorManager/Utils/Models";
import { capitalizeFirstLetter } from "../../../../../../../Generator/src/common/StringUtils";
import { getPreparedText } from "../ErrorItemDescription/Utils/Utils";

import { IconWrapper, ListItem } from "./ErrorsItem.styles";
import { CheckIssueWrapper } from "./InterdocumentCheckIssue.styles";
import { ErrorItemIcon, ErrorItemIconStatus } from "./ErrorItemIcon";

interface InterdocumentIssue {
    id?: string;
    description: string;
    severity?: InterdocumentIssueSeverity;
}

export interface InterdocumentCheckIssueProps {
    type: InterdocumentCheckType;
    issue: InterdocumentIssue;
}

function issueTypeToStatus(checkType: InterdocumentCheckType, issue: InterdocumentIssue): ErrorItemIconStatus {
    if (checkType === InterdocumentCheckType.Fine) {
        return ErrorItemIconStatus.Success;
    }

    if (checkType === InterdocumentCheckType.Issues && issue.severity) {
        return capitalizeFirstLetter(issue.severity) as ErrorItemIconStatus;
    }

    return capitalizeFirstLetter(checkType) as ErrorItemIconStatus;
}

export const InterdocumentCheckIssue = (props: InterdocumentCheckIssueProps) => (
    <CheckIssueWrapper>
        <ListItem>
            <IconWrapper>
                <ErrorItemIcon status={issueTypeToStatus(props.type, props.issue)} />
            </IconWrapper>
            <div data-tid="Description">{getPreparedText(props.issue.description)}</div>
        </ListItem>
    </CheckIssueWrapper>
);
